export type AlertType = 'success' | 'error' | 'warning' | 'info';

export type Toast = {
    id: string;
    type: AlertType;
    message: string;
};

type ToastContainerProps = {
    toasts: Toast[];
    onRemove: (id: string) => void;
};

export const ToastContainer = ({toasts, onRemove}: ToastContainerProps) => {
    if (toasts.length === 0) {
        return null;
    }

    return (
        <div
            className="toast-container"
            role="region"
            aria-label="Notificações"
            aria-live="polite"
            aria-relevant="additions removals"
        >
            {toasts.map((toast) => (
                <ToastItem key={toast.id} {...toast} onClose={() => onRemove(toast.id)} />
            ))}
        </div>
    );
};

type ToastItemProps = {
    id: string;
    type: AlertType;
    message: string;
    onClose: () => void;
};

const TOAST_ICONS: Record<AlertType, string> = {
    success: '✓',
    error: '✕',
    warning: '⚠',
    info: 'ℹ',
};

// Error and warning use role="alert" for immediate announcement
// Success and info use role="status" for polite announcement
const getToastRole = (type: AlertType): 'alert' | 'status' => {
    return type === 'error' || type === 'warning' ? 'alert' : 'status';
};

const ToastItem = ({type, message, onClose}: ToastItemProps) => {
    return (
        <div
            className={`toast toast-${type}`}
            onClick={onClose}
            role={getToastRole(type)}
            aria-atomic="true"
        >
            <span className="toast-icon" aria-hidden="true">
                {TOAST_ICONS[type]}
            </span>
            <span className="toast-message">{message}</span>
        </div>
    );
};
